/* eslint-disable import/extensions */
import React, { Component } from 'react';
import { Button, Table, Input, Modal } from 'antd';
import { connect } from 'dva';
import { parse, stringify } from 'qs';
// import SelectUserCounty from 'nbugs-pc-select-user-with-tag';
import SelectUser from 'nbugs-select-user-pc';

import Container from '@/components/Container';
import { getCurrentBreadCrumbs } from '@/utils';
import downFile from '../services/downFile';
import UploadModal from '../../companents/UploadModal';
import { downloadUrl, uploadUrl, downloadUsersUrl } from '../services/Tags';

import styles from './index.less';

const { Search } = Input;
const { confirm } = Modal;

@connect(({ tagUsers }) => ({
  ...tagUsers,
}))
class TagUsers extends Component {
  constructor(props) {
    super(props);

    const query = parse(window.location.search.split('?').pop());
    const { currentTagId, currentTagType } = query;

    const columns = [
      {
        title: '所属部门',
        dataIndex: '',
        width: '40%',
        render: record => {
          const { departName, orgName } = record;
          if (departName) {
            return <span>{departName}</span>;
          }
          return <span>{orgName}</span>;
        },
      },
      {
        title: '姓名',
        dataIndex: 'userName',
        width: '40%',
      },
      {
        title: '操作',
        width: '20%',
        render: record => (
          <span className="table-action-box">
            <a className="table-action-edit" onClick={() => this.handleDelete({ record })}>
              删除
            </a>
          </span>
        ),
      },
    ];

    this.state = {
      currentPage: 1,
      pageSize: 20,
      columns,
      currentTagId,
      currentTagType,
      showUploadModal: false,
    };
  }

  componentDidMount() {
    this.getList();
  }

  getList = (searchField = null) => {
    const { dispatch } = this.props;
    const { currentTagId, currentPage, pageSize, currentTagType } = this.state;
    dispatch({
      type: 'tagUsers/fetchList',
      payload: {
        type: currentTagType,
        name: searchField,
        tagId: currentTagId,
        page: currentPage,
        pageSize,
      },
    });
  };

  handleDelete = ({ record }) => {
    const { dispatch } = this.props;
    const { currentTagId } = this.state;
    const { id, userName } = record;
    confirm({
      title: `删除人员？`,
      content: `确认删除${userName}?`,
      okText: '确定',
      cancelText: '取消',
      onOk: () => {
        dispatch({
          type: 'tagUsers/fetchDeleteUser',
          payload: {
            tagId: currentTagId,
            id,
          },
          callback: this.getList,
        });
      },
    });
  };

  handleSearch = val => {
    const { pageSize } = this.state;
    if (!val && !val.trim().length) {
      this.handleChangePagination(1, pageSize, this.getList);
    } else {
      this.handleChangePagination(1, pageSize, () => this.getList(val));
    }
  };

  handleChangeSize = (current, pageSize) => {
    this.setState(
      {
        currentPage: current,
        pageSize,
      },
      () => {
        this.getList();
      }
    );
  };

  handleChangePagination = (page, pageSize, callback) => {
    this.setState(
      {
        currentPage: page,
        pageSize,
      },
      () => {
        if (callback && Object.prototype.toString.call(callback) === '[object Function]') {
          callback();
        } else {
          this.getList();
        }
      }
    );
  };

  handleUpload = (showUploadModal = false) => {
    this.setState(
      {
        showUploadModal,
      },
      () => {
        if (!showUploadModal) {
          this.getList();
        }
      }
    );
  };

  handleExport = () => {
    const { currentTagId } = this.state;
    const url = `${downloadUsersUrl}?${stringify({ tagId: currentTagId, type: 2 })}`;
    downFile({
      url,
    });
  };

  handleAddMember = () => {
    this.setState(
      {
        showSelectUser: true,
      },
      () => {
        const selectBtn = document.getElementsByClassName('select-btn')[0];
        selectBtn.children[0].click();
      }
    );
  };

  // 选人组件
  handleConfirm = data => {
    const { currentTagId } = this.state;
    const { dispatch } = this.props;
    const { selectSignature } = data;
    this.handleCancelSelectUser();
    dispatch({
      type: 'tags/submitAddUser',
      payload: {
        tagId: currentTagId,
        selectList: [
          {
            type: 1,
            selectId: selectSignature,
          },
        ],
      },
      callback: () => {
        this.getList();
      },
    });
  };

  handleCancelSelectUser = () => {
    this.setState({
      showSelectUser: false,
    });
  };

  renderTable = () => {
    const { dataSource, totalElements } = this.props;
    const { columns, currentPage } = this.state;
    const tableProps = {
      rowKey: 'id',
      columns,
      dataSource,
      scroll: { y: 560 },

      pagination: {
        pageSizeOptions: ['20', '50', '100', '200'],
        total: totalElements,
        showSizeChanger: true,
        showQuickJumper: true,
        current: currentPage,
        defaultPageSize: 20,
        onChange: this.handleChangePagination,
        onShowSizeChange: this.handleChangeSize,
      },
    };

    if (totalElements > 0) {
      tableProps.footer = () => (
        <div className="table-footer">{`共 ${totalElements} 条记录 第 ${currentPage} 页`}</div>
      );
    }
    return (
      <div className="table-wrap">
        <Table {...tableProps} />
      </div>
    );
  };

  render() {
    const { showUploadModal, currentTagId, showSelectUser } = this.state;

    const { currentTagName } = parse(window.location.search.split('?').pop());

    // 面包屑
    const breadcrumb = getCurrentBreadCrumbs({
      currentUrl: {
        context: currentTagName,
        path: `/contacts/tags/user${window.location.search}`,
      },
      isTop: false,
      storekey: 'managementCenterBreadcrumb',
    });

    return (
      <Container breDataSource={breadcrumb} breStates isBreVersion>
        <div className={styles.tagUsers}>
          <div className="container">
            <div className="header-wrap">
              <div className="left">
                <Button type="primary" onClick={this.handleAddMember}>
                  增加人员
                </Button>
                <Button onClick={() => this.handleUpload(true)}>导入</Button>
                <Button onClick={this.handleExport}>导出</Button>
              </div>
              <div className="right">
                <Search
                  style={{ width: 300 }}
                  placeholder="搜索姓名、所属部门"
                  onSearch={this.handleSearch}
                />
              </div>
            </div>
            {this.renderTable()}

            {showSelectUser && (
              <div style={{ visibility: 'hidden', height: 0 }}>
                <SelectUser
                  appName="通讯录"
                  appId="37"
                  orgType="school"
                  selectType="user"
                  selectSignature=""
                  onOk={this.handleConfirm}
                  onCancel={this.handleCancelSelectUser}
                />
              </div>
            )}
            {showUploadModal && (
              <UploadModal
                uploadData={{ tagId: currentTagId }}
                onCancel={() => this.handleUpload(false)}
                onOk={() => this.handleUpload(false)}
                downUrl={downloadUrl}
                actionUrl={uploadUrl}
                title="批量导入人员"
              />
            )}
          </div>
        </div>
      </Container>
    );
  }
}

export default TagUsers;
